import React, { Component } from 'react';
import Management_Point_Cell from './Management_Point_Cells/Cell';
import { navigateLayout, navigateGroups, navigateDashboard } from '../../Common/navigation';
import { isEmpty } from '../../Common/Common';
import Top_Bar from '../../Part_Sample/Top_Bar';

export default class Group_Details extends Component {
	constructor(props) {
		super(props);

		window.app.hideLoading();

		// Retain scroll position of groups screen
		this.state = {
			scroll_top: 0,
		}

		// group ref for retaining scroll position
		this.mp_ref = React.createRef();
	}

	componentDidMount = () => {
		if (this.props.param.mp_scroll_top != null) {
			this.mp_ref.current.scrollTop = this.props.param.mp_scroll_top;
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		if (this.props.param.from == 'Groups') {
			navigateGroups("null", this.props.param.groups_scroll_top);
		} else if (this.props.param.from == 'Dashboard') {
			navigateDashboard("null");
		} else if (this.props.param.from == 'Layout') {
			window.app.receiver.stored_params.layout_id = this.props.param.layout_id;
			navigateLayout("null");
		}
	}

	handleEdit = () => {
		let param = this.props.param;
		param.group_detail_from = this.props.param.from;
		param.from = 'Group_Details';
		param.original_group_info = param.group_info;
		this.props.content_handler('Group_Edit', param);
	}

	handleDelete = () => {
		this.props.receiver.deleteGroup(this.props.param.group_id);
	}

	handleGroupOperation = () => {
		let param = this.props.param;
		param.group_detail_from = this.props.param.from;
		param.from = 'Group_Details';
		this.props.content_handler('Group_Operation_Screen', param);
	}

	rcvDeleteGroupResponse = (response) => {
		if (!isEmpty(response) && response.result == 'OK') {
			this.handlePrevious();
		}
	}

	handleOnScroll = () => {
		this.setState({
			scroll_top: this.mp_ref.current.scrollTop,
		})
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			overflow: 'auto'
		}

		let is_show_grp_operation = false;

		if (!isEmpty(this.props.param.group_info)) {
			if (this.props.param.group_info.mp != null) {
				for (let point_id of this.props.param.group_info.mp) {
					let point_info = window.app.state.point_list[point_id];
					if (!isEmpty(point_info)) {
						if (['Ac', 'Dehumi', 'Switch', 'LevelSw', 'Hrv', 'Shutter', 'Rgbw'].includes(point_info.type)) {
							is_show_grp_operation = true;
							break;
						}
					}
				}
			}
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString(this.props.param.group_info.name)}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={this.props.receiver.active_controller.user_class == 'Admin' ? 'edit' : null}
						handleRightButton={this.props.receiver.active_controller.user_class == 'Admin' ? this.handleEdit : null}
					/>
					<div id='group_operation' onClick={this.handleGroupOperation} style={{ cursor: 'pointer', display: is_show_grp_operation ? 'block' : 'none', padding: 5, width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto', minWidth: 30, verticalAlign: 'top', textAlign: 'center', cursor: 'pointer', border: '1px solid ' + this.props.colours.appBlue }}>
						<span className='footnote'>{this.props.receiver.getString('group_operation')}</span>
					</div>
					<div ref={this.mp_ref} onScroll={this.handleOnScroll} style={{ marginTop: 10, height: is_show_grp_operation ? this.props.height - 177 : this.props.height - 127, overflow: 'auto', margin: 10 }}>
						{this.props.param.group_info.mp.map((point_id) => {
							let point_info = window.app.state.point_list[point_id];
							if (!isEmpty(point_info)) {

								// Show only the management point the user has access to
								let show_management_point = true;
								if (this.props.receiver.active_controller.user_class != 'Admin') { //Admin class has access to all MP, so do not have to check
									let accessible_points = this.props.receiver.active_controller.auth.points; //list of points user has/has no access to
									show_management_point = false;
									if (accessible_points.hasOwnProperty(point_id)) {
										if (accessible_points[point_id]) {
											show_management_point = true;
										}
									}
								}

								if (show_management_point) {
									return (
										<Management_Point_Cell
											id={'carousel_' + point_id}
											height={this.props.height}
											receiver={this.props.receiver}
											key={point_id}
											point_id={point_id}
											point_info={point_info}
											content_handler={this.props.content_handler}
											group_info={this.props.param.group_info}
											from={'Group_Details'}
											groups={null}
											scenes={null}
											param={this.props.param}
											scroll_top={this.state.scroll_top}
											onClickCell={this.onClickCell}
										/>
									)
								} else {
									return null;
								}
							}
						})}
					</div>
				</div>
			</div>
		)
	}
}